import { TranslationMap } from '@trimble-gcs/i18n-types';

export function importFileListTranslations() {
  return {
    headers: {
      name: {
        text: $localize`:@@import.dialog.fileList.headers.name:File Name`,
        desc: 'Header text for the file name column of the import file list.',
      },
    },
    status: {
      pending: {
        text: $localize`:@@import.dialog.fileList.status.pending:Pending`,
        desc:
          'Tooltip displayed on the file status icon when the import process ' +
          'has started, but the file import has not yet started.',
      },
      progress: {
        text: $localize`:@@import.dialog.fileList.status.progress:Upload progress {percentageComplete}%`,
        desc: 'Tooltip displayed on the file upload progress bar while upload is in progress.',
      },
      completed: {
        text: $localize`:@@import.dialog.fileList.status.completed:Completed`,
        desc: 'Tooltip displayed on the file status icon when the file import has completed.',
      },
      error: {
        text: $localize`:@@import.dialog.fileList.status.error:Something went wrong`,
        desc: 'Tooltip displayed on the file status icon when the file import has failed.',
      },
      skipped: {
        text: $localize`:@@import.dialog.fileList.status.skipped:File Skipped`,
        desc: 'Tooltip displayed on the file status icon when the file import has been skipped.',
      },
    },
    remove: {
      text: $localize`:@@import.dialog.fileList.remove:Remove`,
      desc: 'Tooltip displayed on the remove button for a file in the import file list.',
    },
  } satisfies TranslationMap;
}
